import apiClient from './apiClient';

export const MAX_VIDEO_BYTES = 500 * 1024 * 1024;
export function videoFileError(file) {
  if (!file || !['video/mp4', 'video/webm', 'video/quicktime'].includes(file.type)) {
    return 'Elegí un video MP4, WebM o MOV.';
  }
  if (!file.size || file.size > MAX_VIDEO_BYTES) return 'El video debe pesar entre 1 byte y 500 MB.';
  return '';
}

export async function createVideoUpload(file, callbacks = {}) {
  const error = videoFileError(file);
  if (error) throw new Error(error);
  const [{ data }, { Upload }] = await Promise.all([
    apiClient.post('/media/videos/authorize/', {
      title: file.name.slice(0, 255), size: file.size, content_type: file.type,
    }),
    import('tus-js-client'),
  ]);
  const upload = new Upload(file, {
    endpoint: data.endpoint,
    headers: data.headers,
    metadata: { filetype: file.type, title: file.name },
    chunkSize: 8 * 1024 * 1024,
    retryDelays: [0, 1000, 3000, 5000, 10000],
    storeFingerprintForResuming: false,
    onShouldRetry(error) {
      const status = error.originalResponse?.getStatus();
      return !status || status >= 500 || [409, 423].includes(status);
    },
    onProgress: (sent, total) => callbacks.onProgress?.(Math.round(sent / total * 100)),
    onError: () => callbacks.onError?.('Se interrumpió la carga. Podés reintentar desde el último bloque enviado.'),
    onSuccess: () => callbacks.onSuccess?.(data.video),
  });
  return upload;
}
